document.addEventListener('DOMContentLoaded', () => {

  new Swiper('.ups-swiper', {

    loop: true,

    speed: 1200,

    effect: 'slide',

    preventClicks: false,

    preventClicksPropagation: false,

    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },

    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }

  });


  if (typeof gsap !== 'undefined') {

    gsap.from('.ups-heading', {
      y: 50,
      opacity: 0,
      duration: 1.2,
      ease: 'power3.out'
    });

    gsap.from('.ups-subheading', {
      y: 20,
      opacity: 0,
      duration: 1.3,
      delay: .15,
      ease: 'power3.out'
    });

  }

});